import { ReactElement } from "react";

import { Heading } from "../components/catalyst/Heading.tsx";

export const PageNotFound = (): ReactElement => {
  return <Heading level={1}>Page not found</Heading>;
};
